import { useQuery } from "react-query";
import { fetchPatientLetters } from "@/services/patient-content";
/** Query hook for the patient's attachable letters, enabled on demand. */
export function usePatientLetters(patientId, enabled) {
  return useQuery(["patient-letters", patientId], function () {
    return fetchPatientLetters(patientId);
  }, {
    enabled: enabled && Boolean(patientId)
  });
}